import { AddressBookDownloadTemplateType, GetAddressBookDownloadTemplate } from '../analytics-context-types';
import { getPODModalTag, getPODProductTag } from './utils';

// "download xlsx template" OR "download csv template"
const eventAction: Record<AddressBookDownloadTemplateType, string> = {
  xlsx: 'download xlsx template',
  csv: 'download csv template',
};

export const getAddressBookDownloadTemplateTag = (options: GetAddressBookDownloadTemplate) => {
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const addressBookDownloadTemplateEvent = [
    {
      eventInfo: {
        eventName: 'download template',
        eventAction: eventAction[options.templateType],
      },
    },
  ];

  const { modal, user } = getPODModalTag(
    'Address the Envelope - Recipient',
    addressBookDownloadTemplateEvent,
    options.projectID,
  );

  return {
    modal,
    product,
    user,
  };
};
